module.exports = __webpack_public_path__ + "media/images/win-bcd18c9251e189e03020013f7879c883.png";